import { IApplicationState } from '../../types/redux';

export const selectIsMobileAppNavbarAvailable = (state: IApplicationState) => {
  return state.dropdown.isMobileAppNavbarAvailable;
};
